/**
 * Reducer for any errors that might need to appear
 */

import { ActionTypes as types } from '../constants'

const initialState = {}

/**
 * Reducer. Pure function that mutates this part of the store
 * and returns a new obj.
 *
 */
export default function errors(state = initialState, action) {
  const { data } = action

  switch (action.type) {
    case types.SHOW_ERROR_BANNER:
      return {
        ...state,
        banner: { message: data.message },
      }
    case types.SHOW_ERROR_PAGE:
      return {
        ...state,
        page: data.errorCode,
      }
    default:
      // any other action resets the current error
      return {
        ...state,
        banner: null,
        page: null,
      }
  }
}
